/**
 * Contact Animation Module
 * Animate contact items and map on scroll with GSAP
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ContactAnimation {
  constructor() {
    this.initContactItems();
    this.initMap();
  }

  initContactItems() {
    const items = document.querySelectorAll('.contact-item');
    
    if (!items || items.length === 0) {
      return;
    }

    items.forEach((item, index) => {
      gsap.to(item, {
        opacity: 1,
        x: 0,
        duration: 0.6,
        ease: 'power2.out',
        delay: index * 0.15,
        scrollTrigger: {
          trigger: item,
          start: 'top 85%',
          once: true,
        },
        onComplete: () => {
          item.classList.add('animated');
        }
      });
    });
  }

  initMap() {
    const map = document.querySelector('.contact-info-section__map');
    
    if (!map) {
      return;
    }

    gsap.to(map, {
      opacity: 1,
      x: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: map,
        start: 'top 85%',
        once: true,
      },
      onComplete: () => {
        map.classList.add('animated');
      }
    });
  }
}
